export default "__VITE_ASSET__DV4Dp1_g__"